module.exports = __webpack_public_path__ + "img/topicSurveys.70e39ab4.png";